<template>
  <LayoutDefault>
    <div
            class="container dark"
            id="tokens"
    >
      <template v-if="$auth.ready() && $auth.check()">
        <section class="block">
            <PaymentHistoryTable />
        </section>
        <section class="block" style="display:flex;align-content: space-between;align-items: center; margin: 1rem auto;">
          <div style="flex:1;">
            <router-link
              class="support-link"
              :to="{name: 'support'}">
              {{ $t('zammad_support.link') }}
            </router-link>
          </div>
          <div>
            <a    
              @click="goBackOrHome" class="btn-go-back">&laquo; 
              {{ $t('dashboard.back') }}
            </a>
          </div>
        </section>
      </template>
    </div>
  </LayoutDefault>
</template>
<script>
import LayoutDefault from "../layouts/LayoutDefault";
import Spinner from "../components/Spinner";
import PaymentHistoryTable from "../components/PaymentHistoryTable";

export default {
      components: {
        LayoutDefault,
        Spinner,
        PaymentHistoryTable,
      },
      methods: {
    goBackOrHome() {
      if (this.$route.meta.previousRoute) {
        // Si hay una ruta anterior almacenada, redirigimos a ella
        this.$router.push(this.$route.meta.previousRoute);
      } else {
        // Si no hay una ruta anterior almacenada, redirigimos al home
        this.$router.push({ name: "home" });
      }
    }
  }
    }
</script>
<style scoped lang="scss">
@import '../styles/variables';
@import '../styles/classes';
#tokens{
  box-sizing: border-box;
  min-height: 500px;
  padding: 9px;
}

.block {
  margin:0 auto;
  width: 75%;
}

.buy_tokens_button {
  box-sizing: border-box;
  background-color: var(--pallete_main_color);
  padding: 0.5rem;
  margin: 1rem 0 0.5rem 0;
}

.support-link {
  &:hover {
    font-weight: bold;
  }
}

.btn-go-back {
  color: var(--pallete_main_color);
  &:hover {
    cursor: pointer;
    font-weight: bold;
  }
}
</style>